import { useRef } from 'react';
import { latestManga } from '@/mocks/manga';
import MangaCard from './MangaCard';
import SectionHeader from './SectionHeader';

export default function LatestSection() {
  const trackRef = useRef<HTMLDivElement>(null);

  const slide = (dir: number) => {
    const el = trackRef.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: 'smooth' });
  };

  return (
    <section id="latest" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <SectionHeader
            eyebrow="每日更新"
            title="最新更新抢先看"
            desc="飞飞漫画网每日极速同步更新，翻页流畅即刻追读最新章节。"
          />
          <div className="hidden shrink-0 items-center gap-2 md:flex">
            <button
              type="button"
              onClick={() => slide(-1)}
              aria-label="上一组"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500 cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              type="button"
              onClick={() => slide(1)}
              aria-label="下一组"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500 cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={trackRef}
          className="mt-8 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 md:gap-5 [scrollbar-width:thin]"
        >
          {latestManga.map((m) => (
            <div key={m.id} className="w-[150px] shrink-0 snap-start sm:w-[160px] md:w-[172px]">
              <MangaCard manga={m} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}